// #334: once a year view mixes past and future, a card has to say which it is.
// Amber rather than slate: slate is the card's own chrome and the label would
// vanish into it, and this is a fact about the event, not a disabled state.
export default function PastPill() {
  return (
    <span className="inline-flex items-center rounded-full bg-amber-100 px-2.5 py-0.5 text-xs font-medium text-amber-800">
      past
    </span>
  )
}
